export default {
      id: "icon-infos-usage",
      viewBox: "0 0 29 29.983",
      url: __webpack_public_path__ + "icons.svg#icon-infos",
      toString: function () {
        return this.url;
      }
    }